import { render, staticRenderFns } from "./CommunityCaseCover.vue?vue&type=template&id=2a7776c8&scoped=true"
import script from "./CommunityCaseCover.vue?vue&type=script&lang=js"
export * from "./CommunityCaseCover.vue?vue&type=script&lang=js"
import style0 from "./CommunityCaseCover.vue?vue&type=style&index=0&id=2a7776c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7776c8",
  null
  
)

export default component.exports